import React from 'react';
import { autobind } from 'core-decorators';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import InputSearch from 'src/componentes/input-search';
import LucideIcon from 'src/componentes/lucide-icon';
import LoadingContainer from 'src/componentes/loading-container';
import TipoAcessoLookup from 'src/lookups/tipo-acesso';
import TipoAcessoPacoteLookup from 'src/lookups/tipo-acesso-pacote';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

@autobind
class Permissoes extends React.Component {
  static defaultProps = {
    allowEditPermissions: true,
  };

  acessoColumnWidth = 240;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      list: [],
      idsExpandidos: [],
      searchText: '',
      filteredList: [],
    };
  }

  componentDidMount() {
    this.refresh();
  }

  componentWillUnmount() {
    clearTimeout(this.searchDebounceId);
  }

  refresh() {
    this.setState({
      isLoading: true,
    });
    if (this.props.colaboradorId) {
      http
        .post(`${this.props.urlLoad}`, {
          colaboradorId: this.props.colaboradorId,
        })
        .then((response) => {
          const newList = response?.data?.list || [];

          const filteredList = 
            this.state.searchText && this.state.searchText !== ''
              ? this.getFilteredList(newList, false)
              : newList;

          this.setState({
            isLoading: false,
            ...response.data,
            filteredList,
          });
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          errorHandler(error);
        });
    }
  }

  ehGrupo(permissao) {
    return !!(permissao.filhos && permissao.filhos.length);
  }

  estaExpandido(permissao) {
    return this.state.idsExpandidos.indexOf(permissao.organizacaoId) !== -1;
  }

  toggle(permissao) {
    if (this.estaExpandido(permissao)) {
      this.setState({
        idsExpandidos: this.state.idsExpandidos.filter(
          (organizacaoId) => organizacaoId !== permissao.organizacaoId
        ),
      });
    } else {
      this.setState({
        idsExpandidos: this.state.idsExpandidos.concat([
          permissao.organizacaoId,
        ]),
      });
    }
  }

  handleSearchChange(value) {
    if (value) {
      this.setState({ searchText: value.target.value });

      clearTimeout(this.searchDebounceId);
      this.searchDebounceId = setTimeout(() => {
        this.setState({ filteredList: this.getFilteredList(this.state.list) });
      }, 1000);
    }
    if (!value.target.value || value.target.value === '') this.setState({ idsExpandidos: [] });
  }

  getFilteredList(list, expand = true) {
    const { searchText } = this.state;
    if (!searchText || searchText === '') {
      return list;
    }

    const search = searchText.toLowerCase();
    const idsToExpand = [];

    const filterItem = (item) => {
      const descricao = item.descricao ? item.descricao.toString().toLowerCase() : '';
      const match = descricao.includes(search);

      let filhos = [];
      if (item.filhos && item.filhos.length) {
        filhos = item.filhos
          .map(filterItem)
          .filter((x) => x);
      }

      if (filhos.length) {
        idsToExpand.push(item.organizacaoId);
      }
      
      if (match && item.filhos && item.filhos.length > 0) {
        filhos = item.filhos;
      }

      if (match || filhos.length) {
        return { ...item, filhos };
      }

      return null;
    };

    const filteredList = (list || []).map(filterItem).filter((x) => x);

    if (expand) {
      this.setState({ idsExpandidos: idsToExpand });
    }

    return filteredList;
  }

  getItemLabel(campo, item) {
    if (!item) {
      return;
    }

    if (campo.labelFunction) {
      return campo.labelFunction(item);
    }

    if (campo.labelField) {
      return item[campo.labelField];
    }

    return item;
  }

  handlePermissaoAcessoChange(permissao, valor) {
    http
      .post(`${this.props.urlSave}`, {
        permissaoId: permissao ? permissao.id : 0,
        tipoAcessoId: valor ? valor.id : 0,
        organizacaoId: permissao ? permissao.organizacaoId : 0,
        colaboradorId: this.props.colaboradorId,
      })
      .then((response) => {
        this.setState({
          isLoading: false,
          ...response.data,
        }, () => this.refresh());
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });
  }

  handleReplicarPermissaoAcessoChange(permissao) {
    http
      .post(`${this.props.urlReply}`, {
        colaboradorId: this.props.colaboradorId,
        permissaoId: permissao ? permissao.id : 0,
        organizacaoId: permissao ? permissao.organizacaoId : 0,
      })
      .then((response) => {
        this.setState({
          isLoading: false,
          ...response.data,
        }, () => this.refresh());
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });
  }

  renderFuncionalidade(permissao, index, level = 0, paiSelecionado) {
    let { allowEditPermissions } = this.props;

    let selecionado = permissao.selecionado;

    const tooltipId = `TOOLTIP-P-${permissao?.organizacaoId}`;

    return [].concat(
      <tr key={permissao.organizacaoId}>
        <td
          style={{
            paddingLeft: level * 20,
            whiteSpace: `nowrap`,
            verticalAlign: `middle`,
          }}
        >
          <div className="d-flex align-items-center w-100">
            {this.ehGrupo(permissao) ? (
              <LucideIcon
                icon={
                  this.estaExpandido(permissao)
                    ? `chevron-down`
                    : `chevron-right`
                }
                size={20}
                onClick={this.toggle.bind(this, permissao)}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <div style={{ display: `inline-block`, width: 20 }}></div>
            )}
            <div
              className="text-truncate flex-grow-1"
              style={{ minWidth: 0 }}
              title={permissao.descricao}
            >
              {permissao.descricao}
            </div>
          </div>
        </td>
        <td style={{ width: this.acessoColumnWidth, verticalAlign: `middle` }}>
          {this.props.tipo === 3 ? (
            <TipoAcessoPacoteLookup
              style={{ marginBottom: 0 }}
              model={{
                value: permissao.acesso,
                requestChange: this.handlePermissaoAcessoChange.bind(
                  this,
                  permissao
                ),
              }}
              disabled={!allowEditPermissions}
            />
          ) : (
            <TipoAcessoLookup
              style={{ marginBottom: 0 }}
              model={{
                value: permissao.acesso,
                requestChange: this.handlePermissaoAcessoChange.bind(
                  this,
                  permissao
                ),
              }}
              disabled={!allowEditPermissions}
            />
          )}
        </td>
        {permissao.filhos &&
        permissao.filhos.length > 0 &&
        allowEditPermissions ? (
          <td style={{ width: 60, verticalAlign: `middle` }}>
            <div
              className="d-flex items-center"
              id={tooltipId}
              data-tip
              data-for={tooltipId}
            >
              <LucideIcon
                icon="arrow-down-bold-circle-outline"
                size={20}
                onClick={this.handleReplicarPermissaoAcessoChange.bind(
                  this,
                  permissao
                )}
                className="cursor-pointer"
              />
              <ReactTooltip id={tooltipId} aria-haspopup="true">
                <FormattedMessage id="label.replicarParaFilhos" />
              </ReactTooltip>
            </div>
          </td>
        ) : (
          <td style={{ width: 60, verticalAlign: `middle` }}></td>
        )}
      </tr>,
      ...(this.estaExpandido(permissao)
        ? permissao.filhos &&
          permissao.filhos.length > 0 &&
          permissao.filhos.map((m, i) =>
            this.renderFuncionalidade(
              m,
              i,
              level + 1,
              paiSelecionado || selecionado
            )
          )
        : [])
    );
  }

  render() {
    let { columns, intl } = this.props;
    let list = this.state.searchText ? this.state.filteredList : this.state.list;

    return (
      <LoadingContainer isLoading={this.state.isLoading}>
        <div style={{ width: 187, minWidth: 187, marginBottom: '24px' }} className="d-inline-flex">
          <InputSearch
            placeholder={intl.formatMessage({
              id: 'label.pesquisaRapida',
            })}
            autoFocus
            value={this.state.searchText}
            onChange={this.handleSearchChange}
            disabled={this.state.isLoading}
          />
        </div>
        <Table
          style={{ overflowY: 'hidden', width: `100%`, tableLayout: `fixed` }}
        >
          <thead>
            <tr>
              {columns &&
                columns.length > 0 &&
                columns.map((item, index) => (
                  <th
                    key={index}
                    style={index === 1 ? { width: this.acessoColumnWidth } : {}}
                  >
                    {item.headerText}
                  </th>
                ))}
              <th style={{ width: 60 }}></th>
            </tr>
          </thead>
          <tbody>
            {list &&
              list.length > 0 &&
              list.map((permissao, index) =>
                this.renderFuncionalidade(permissao, index)
              )}
          </tbody>
        </Table>
      </LoadingContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(Permissoes));
